import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.13",
  "description": "Turborepo 1.13 brings a new and improved local development experience along with other enhancements.",
  "date": "2024/03/21",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.13 brings a new and improved local development experience along with other enhancements, including:"
  }, {
    "heading": "",
    "content": "New terminal UI : Interact with your tasks locally in an enhanced terminal experience"
  }, {
    "heading": "",
    "content": "Enable the fastest defaults: Make your local development environment faster with turbo scan"
  }, {
    "heading": "",
    "content": "CI logging improvements: Support for four major providers and automatic unfurling of errored tasks"
  }, {
    "heading": "",
    "content": "Enhanced prune support: Bug fixes and improved stability for turbo prune"
  }, {
    "heading": "",
    "content": "Update today by running npx @turbo/codemod migrate or get started with npx create-turbo@latest."
  }, {
    "heading": "new-terminal-ui",
    "content": "Until today, turbo would output logs as a stream while you were working on your libraries and applications. This could be overwhelming at times since the interleaved logs made it difficult to understand what was going on with a specific task."
  }, {
    "heading": "new-terminal-ui",
    "content": "With this release, we’re shipping a new, experimental terminal UI, which allows you to:"
  }, {
    "heading": "new-terminal-ui",
    "content": "Toggle through the logs of each of your tasks, making them easier to follow and read"
  }, {
    "heading": "new-terminal-ui",
    "content": "Interact with your persistent tasks by entering and exiting the task’s shell, giving you the ability to re-run unit tests, for example"
  }, {
    "heading": "new-terminal-ui",
    "content": "See the duration for each of your tasks in a bar graph"
  }, {
    "heading": "new-terminal-ui",
    "content": "To enable the new UI, either use the --experimental-ui flag or add the experimentalUI flag to your turbo.json:"
  }, {
    "heading": "new-terminal-ui",
    "content": "We are looking forward to hearing your feedback on this new feature. Please visit the RFC on GitHub Discussions to share your thoughts."
  }, {
    "heading": "enable-the-fastest-defaults",
    "content": "We want your local development experience to be as fast as possible - through even more than the parallelization and caching of turbo."
  }, {
    "heading": "enable-the-fastest-defaults",
    "content": "Running turbo scan will inspect your machine for optimizations that make your experience faster."
  }, {
    "heading": "enable-the-fastest-defaults",
    "content": "For more information, visit the documentation."
  }, {
    "heading": "enable-the-fastest-defaults",
    "content": "This command is for your local development environment. It will not optimize\nyour CI."
  }, {
    "heading": "ci-logging-improvements",
    "content": "This release adds support for automatically grouping successful logs in:"
  }, {
    "heading": "ci-logging-improvements",
    "content": "Azure Pipelines"
  }, {
    "heading": "ci-logging-improvements",
    "content": "TeamCity"
  }, {
    "heading": "ci-logging-improvements",
    "content": "Travis CI"
  }, {
    "heading": "ci-logging-improvements",
    "content": "These providers join GitHub Actions, which was already supported."
  }, {
    "heading": "ci-logging-improvements",
    "content": "Additionally, Turborepo now ungroups any tasks that did not complete successfully so you can find errorful tasks faster."
  }, {
    "heading": "enhanced-package-manager-support-for-prune",
    "content": "Turborepo’s prune command is an important optimization for Docker users, helping them to create lightweight images from monorepos."
  }, {
    "heading": "enhanced-package-manager-support-for-prune",
    "content": "pnpm lockfile support has been upgraded by adding support for Workspace relative path references and respecting the link-workspace-packages property in .npmrc."
  }, {
    "heading": "enhanced-package-manager-support-for-prune",
    "content": "Yarn4 support has been improved by supporting resolutions in package.json at the root of your Workspace."
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo 1.12 we've seen incredible adoption and community growth:"
  }, {
    "heading": "community",
    "content": "24.6k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "2.3M+ weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "283 years of compute time saved using Vercel Remote Cache"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team."
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "new-terminal-ui",
    "content": "New terminal UI"
  }, {
    "id": "enable-the-fastest-defaults",
    "content": "Enable the fastest defaults"
  }, {
    "id": "ci-logging-improvements",
    "content": "CI logging improvements"
  }, {
    "id": "enhanced-package-manager-support-for-prune",
    "content": "Enhanced package manager support for prune"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
import {ThemeAwareImage} from '#components/theme-aware-image';
import {ExperimentalBadge} from '#components/experimental-badge';
export const toc = [{
  depth: 2,
  url: "#new-terminal-ui",
  title: _jsx(_Fragment, {
    children: "New terminal UI"
  })
}, {
  depth: 2,
  url: "#enable-the-fastest-defaults",
  title: _jsx(_Fragment, {
    children: "Enable the fastest defaults"
  })
}, {
  depth: 2,
  url: "#ci-logging-improvements",
  title: _jsx(_Fragment, {
    children: "CI logging improvements"
  })
}, {
  depth: 2,
  url: "#enhanced-package-manager-support-for-prune",
  title: _jsxs(_Fragment, {
    children: ["Enhanced package manager support for ", _jsx("code", {
      children: "prune"
    })]
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.13"
    }), "\n", "\n", _jsx(Date, {
      children: "Thursday, March 21st, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['gregsoltis', 'chrisolszewski']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.13 brings a new and improved local development experience along with other enhancements, including:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#new-terminal-ui",
          children: _jsx(_components.strong, {
            children: "New terminal UI"
          })
        }), " ", _jsx(ExperimentalBadge, {}), ": Interact with your tasks locally in an enhanced terminal experience"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#enable-the-fastest-defaults",
          children: _jsx(_components.strong, {
            children: "Enable the fastest defaults"
          })
        }), ": Make your local development environment faster with ", _jsx(_components.code, {
          children: "turbo scan"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#ci-logging-improvements",
          children: _jsx(_components.strong, {
            children: "CI logging improvements"
          })
        }), ": Support for four major providers and automatic unfurling of errored tasks"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#enhanced-package-manager-support-for-prune",
          children: _jsxs(_components.strong, {
            children: ["Enhanced ", _jsx(_components.code, {
              children: "prune"
            }), " support"]
          })
        }), ": Bug fixes and improved stability for ", _jsx(_components.code, {
          children: "turbo prune"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), " or get started with ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "new-terminal-ui",
      children: "New terminal UI"
    }), "\n", _jsxs(_components.p, {
      children: ["Until today, ", _jsx(_components.code, {
        children: "turbo"
      }), " would output logs as a stream while you were working on your libraries and applications. This could be overwhelming at times since the interleaved logs made it difficult to understand what was going on with a specific task."]
    }), "\n", _jsx(_components.p, {
      children: "With this release, we’re shipping a new, experimental terminal UI, which allows you to:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Toggle through the logs of each of your tasks"
        }), ", making them easier to follow and read"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Interact with your persistent tasks"
        }), " by entering and exiting the task’s shell, giving you the ability to re-run unit tests, for example"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "See the duration for each of your tasks"
        }), " in a bar graph"]
      }), "\n"]
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'A screenshot of a terminal running `turbo scan`.',
        src: '/images/blog/turbo-1-13-0/experimental-ui.gif',
        props: {
          width: 800,
          height: 350,
          className: 'dark:hidden block'
        }
      },
      dark: {
        alt: 'A screenshot of a terminal running `turbo scan`.',
        src: '/images/blog/turbo-1-13-0/experimental-ui.gif',
        props: {
          width: 800,
          height: 350,
          className: 'hidden dark:block'
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["To enable the new UI, either use the ", _jsx(_components.code, {
        children: "--experimental-ui"
      }), " flag or add the ", _jsx(_components.code, {
        children: "experimentalUI"
      }), " flag to your ", _jsx(_components.code, {
        children: "turbo.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"experimentalUI\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "We are looking forward to hearing your feedback on this new feature."
      }), " Please ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/discussions/7802",
        children: "visit the RFC on GitHub Discussions"
      }), " to share your thoughts."]
    }), "\n", _jsx(_components.h2, {
      id: "enable-the-fastest-defaults",
      children: "Enable the fastest defaults"
    }), "\n", _jsxs(_components.p, {
      children: ["We want your local development experience to be as fast as possible - through even more than the parallelization and caching of ", _jsx(_components.code, {
        children: "turbo"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Running ", _jsx(_components.code, {
        children: "turbo scan"
      }), " will inspect your machine for optimizations that make your experience faster."]
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: 'A screenshot of a terminal running `turbo scan`.',
        src: '/images/blog/turbo-1-13-0/turbo-scan-light.png',
        props: {
          width: 934,
          height: 869,
          className: 'dark:hidden block rounded-xl border border-2'
        }
      },
      dark: {
        alt: 'A screenshot of a terminal running `turbo scan`.',
        src: '/images/blog/turbo-1-13-0/turbo-scan-dark.png',
        props: {
          width: 1868,
          height: 1800,
          className: 'hidden dark:block rounded-xl border border-2 dark:border-gray-700'
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["For more information, ", _jsx(_components.a, {
        href: "/docs/reference/scan",
        children: "visit the documentation"
      }), "."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsx(_components.p, {
        children: "This command is for your local development environment. It will not optimize\nyour CI."
      })
    }), "\n", _jsx(_components.h2, {
      id: "ci-logging-improvements",
      children: "CI logging improvements"
    }), "\n", _jsx(_components.p, {
      children: "This release adds support for automatically grouping successful logs in:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Azure Pipelines"
      }), "\n", _jsx(_components.li, {
        children: "TeamCity"
      }), "\n", _jsx(_components.li, {
        children: "Travis CI"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "These providers join GitHub Actions, which was already supported."
    }), "\n", _jsx(_components.p, {
      children: "Additionally, Turborepo now ungroups any tasks that did not complete successfully so you can find errorful tasks faster."
    }), "\n", _jsx(ThemeAwareImage, {
      className: "my-4 flex justify-center",
      light: {
        alt: "A screenshot of a GitHub Action that ran a `turbo` task. The logs for tasks that completed successfully are folded while the errored task shows it's logs in full with red highlighting.",
        src: '/images/blog/turbo-1-13-0/github-action.png',
        props: {
          width: 3306,
          height: 2607,
          className: 'dark:hidden block rounded-xl'
        }
      },
      dark: {
        alt: "A screenshot of a GitHub Action that ran a `turbo` task. The logs for tasks that completed successfully are folded while the errored task shows it's logs in full with red highlighting.",
        src: '/images/blog/turbo-1-13-0/github-action.png',
        props: {
          width: 3306,
          height: 2607,
          className: 'hidden dark:block rounded-xl'
        }
      }
    }), "\n", _jsxs(_components.h2, {
      id: "enhanced-package-manager-support-for-prune",
      children: ["Enhanced package manager support for ", _jsx(_components.code, {
        children: "prune"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo’s ", _jsx(_components.code, {
        children: "prune"
      }), " command is an important optimization for Docker users, helping them to create lightweight images from monorepos."]
    }), "\n", _jsxs(_components.p, {
      children: ["pnpm lockfile support has been upgraded by adding support for ", _jsx(_components.a, {
        href: "https://pnpm.io/workspaces#referencing-workspace-packages-through-their-relative-path",
        children: "Workspace relative path references"
      }), " and respecting the ", _jsxs(_components.a, {
        href: "https://pnpm.io/npmrc#link-workspace-packages",
        children: [_jsx(_components.code, {
          children: "link-workspace-packages"
        }), " property in ", _jsx(_components.code, {
          children: ".npmrc"
        })]
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Yarn4 support has been improved by supporting ", _jsxs(_components.a, {
        href: "https://yarnpkg.com/configuration/manifest#resolutions",
        children: [_jsx(_components.code, {
          children: "resolutions"
        }), " in ", _jsx(_components.code, {
          children: "package.json"
        })]
      }), " at the root of your Workspace."]
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "/blog/turbo-1-12-0",
        children: "Turborepo 1.12"
      }), " we've seen incredible adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "24.6k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "2.3M+ weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["283 years of compute time saved using ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel Remote Cache"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of all of its contributors, including our core team."
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
